import { createClient } from '@supabase/supabase-js'

const url = typeof import.meta.env.VITE_SUPABASE_URL === 'string'
  ? import.meta.env.VITE_SUPABASE_URL.trim()
  : import.meta.env.VITE_SUPABASE_URL
const key = typeof import.meta.env.VITE_SUPABASE_ANON_KEY === 'string'
  ? import.meta.env.VITE_SUPABASE_ANON_KEY.trim()
  : import.meta.env.VITE_SUPABASE_ANON_KEY

// Cloudflare Pages (and other hosts) often ship a build without VITE_* vars first.
// createClient(undefined, …) throws immediately and leaves a white screen.
const resolvedUrl = typeof url === 'string' && url.length > 0 ? url : 'https://placeholder.supabase.co'
const resolvedKey =
  typeof key === 'string' && key.length > 0 ? key : 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.e30.invalid'

if (!url || !key) {
  console.warn(
    '[ClosedRecord] Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY. Add them under Cloudflare Pages → Settings → Environment variables, then redeploy. Using a placeholder client until then.',
  )
}

export const supabase = createClient(resolvedUrl, resolvedKey)
